import React, { useEffect, useState } from "react"
import GraphStatsDescend from "../../../assets/images/icons/graph-stats-descend.svg"
import MoneyBag from "../../../assets/images/icons/money-bag.svg"
import MultipleUsers from "../../../assets/images/icons/multiple-users.svg"
import ShoppingBasket from "../../../assets/images/icons/shopping-basket.svg"
import GraphStats from "../../../assets/images/icons/graph-stats.svg"
import { useLazyGetWealthDashboardStatsQuery } from "store/api/wealthpartnerapi/wealthReport"
import { formatAmount } from "helpers/common"
import WealthPartnerStatsSk from "components/Skeltons/dashboard/WealthPartnerStatsSk"

const WealthPartnerDashboardStats = () => {
  const [getResults, { isFetching }] = useLazyGetWealthDashboardStatsQuery()
  const [data, setData] = useState(null)

  const getList = async () => {
    try {
      const { data } = await getResults().unwrap()
      setData(data)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [])

  return (
    <React.Fragment>
      {isFetching && !data ? (
        <WealthPartnerStatsSk />
      ) : (
        <>
          <div className="user-dashboard-card-box">
            <div className="card-box-wrapper-section">
              <div className="card-box">
                <div className="heading-text">
                  <img src={MoneyBag} alt="" />
                  <h5>Total Commission Earned</h5>
                </div>
                <div className="amount-section">
                  <h4>₹ {formatAmount(data?.commission?.total)}</h4>
                  <div
                    className={`value ${data?.commission?.growthSign === "+" ? "increase" : ""}`}
                  >
                    <img
                      src={
                        data?.commission?.growthSign === "+"
                          ? GraphStats
                          : GraphStatsDescend
                      }
                      alt=""
                    />
                    {data?.commission?.growth}
                  </div>
                </div>
              </div>
              <div className="card-bottom-section">
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      data?.commission?.growthSign === "+"
                        ? `You can doing <strong>excellent</strong> this month`
                        : `You can earn <strong>more</strong> this month`,
                  }}
                />
              </div>
            </div>
            <div className="card-box-wrapper-section">
              <div className="card-box">
                <div className="heading-text">
                  <img src={ShoppingBasket} alt="" />
                  <h5>Total ICD Volume</h5>
                </div>
                <div className="amount-section">
                  <h4>₹ {formatAmount(data?.icdVolume?.total)}</h4>
                  <div
                    className={`value ${data?.icdVolume?.growthSign === "+" ? "increase" : ""}`}
                  >
                    <img
                      src={
                        data?.icdVolume?.growthSign === "+"
                          ? GraphStats
                          : GraphStatsDescend
                      }
                      alt=""
                    />
                    {data?.icdVolume?.growth}
                  </div>
                </div>
              </div>
              <div className="card-bottom-section">
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      data?.icdVolume?.currentMonth > data?.icdVolume?.lastMonth
                        ? `ICD Investment increased by <strong>₹ ${formatAmount(data?.icdVolume?.currentMonth - data?.icdVolume?.lastMonth)}</strong> this month`
                        : `ICD Investment fell by <strong>₹ ${formatAmount(data?.icdVolume?.lastMonth - data?.icdVolume?.currentMonth)}</strong> this month`,
                  }}
                />
              </div>
            </div>
            <div className="card-box-wrapper-section">
              <div className="card-box">
                <div className="heading-text">
                  <img src={MultipleUsers} alt="" />
                  <h5>No. of Clients</h5>
                </div>
                <div className="amount-section">
                  <h4>{data?.clients?.total}</h4>
                  <div
                    className={`value ${data?.clients?.growthSign === "+" ? "increase" : ""}`}
                  >
                    <img
                      src={
                        data?.clients?.growthSign === "+"
                          ? GraphStats
                          : GraphStatsDescend
                      }
                      alt=""
                    />
                    {data?.clients?.growth}
                  </div>
                </div>
              </div>
              <div className="card-bottom-section">
                <p>
                  Onboarded <strong>{data?.clients?.currentMonth}</strong> new
                  client{data?.clients?.currentMonth === 1 ? "" : "s"} this
                  month
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  )
}

export default WealthPartnerDashboardStats
